export const cabinetEmployeeTypes = {
  DashboardService: Symbol.for('CabinetEmployeeDashboardService'),

  GetDashboardUseCase: Symbol.for('CabinetEmployeeGetDashboardUseCase'),
}
